import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from "react";
import { PageTitle } from "@jti/ui";
import NewPasswordForm from "./NewPasswordForm";
import ResetSuccessful from "./ResetSuccessful";
import styles from "./NewPassword.module.scss";
const NewPassword = ({ ctaButtonText, passwordAction, subtitle, successMessage, title, hasConsents, }) => {
    const [isPasswordChanged, setIsPasswordChanged] = useState(false);
    const handlePasswordChange = () => {
        setIsPasswordChanged(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: title, text: !isPasswordChanged && subtitle }), _jsx("div", { className: styles.container, children: isPasswordChanged ? (_jsx(ResetSuccessful, { successMessage: successMessage })) : (_jsx(NewPasswordForm, { ctaButtonText: ctaButtonText, onPasswordChangeSuccess: handlePasswordChange, passwordAction: passwordAction, hasConsents: hasConsents })) })] }));
};
export default memo(NewPassword);
